<template>
<div>
    <b-modal id="trademarkOppositionBasisForOppositionFormModal" centered size="xl" no-close-on-backdrop ref="trademarkOppositionBasisForOppositionFormModal" :title="$t('trademarkOppositionBasisForOpposition.info')" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" @close="close()" hide-footer>
        <trademark-opposition-basis-for-opposition-form-list :trademarkOppositionId=this.trademarkOppositionId></trademark-opposition-basis-for-opposition-form-list>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getTrademarkOppositionBasisForOppositionList: {
            type: Function,
        },
        getTrademarkOppositionList: {
            type: Function,
        },
    },
    data() {
        return {
            id: 0,
            trademarkOppositionId: null,
        };
    },
    methods: {
        close() {
            this.getTrademarkOppositionBasisForOppositionList();
        },
        showInfo(trademarkOppositionId) {
            this.trademarkOppositionId = trademarkOppositionId
            this.$refs['trademarkOppositionBasisForOppositionFormModal'].show()
        },
    },
};
</script>
